import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-complaint-info',
    templateUrl: './complaint-info.component.html',
    styleUrls: ['./complaint-info.component.scss'],
})
export class ComplaintInfoComponent {

    constructor (
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            info: string;
        },
    ) {}

    close() {
        this.dialogRef.close();
    }
}
